import airplayButton from './airplay-button';
import chromecast from './chromecast';
import eventTracking from './event-tracking';
import ima from './ima';
import kijkwijzerPlugin from './kijkwijzer';
import qualityselector from './quality-selector';
import share from './share';
import titleoverlay from './titleoverlay';
import watermark from './watermark';

// You can add or remove plugins here
export const videoPlugins = {
  eventTracking,
  titleoverlay,
  airplayButton,
  chromecast,
  watermark,
  ima,
  share,
  qualityselector,
  kijkwijzerPlugin,
};

export const audioPlugins = {
  watermark,
  share,
};
